import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromModels from '../../models/rootState.model';

export const selectSportsState = createFeatureSelector<fromModels.SportsState>('sports');
export const selectSportsLoaded = createSelector(selectSportsState, state => state.loaded);
export const selectSportsLoading = createSelector(selectSportsState, state => state.loading);
export const selectSportsLoadedTime = createSelector(selectSportsState, state => state.loaded_time);
export const selectSports = createSelector(selectSportsState, state => state.sports);